var render = function render(){var _vm=this,_c=_vm._self._c;return _c('item-wrapper',[_c('template',{slot:"title"},[_c('title-wrapper',{attrs:{"title":"工单趋势"}})],1),_c('template',{slot:"content"},[_c('trend')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }